import axios from "./axios";
import { ADMIN_API_ROOT } from "./api-root";

export const AmountServer = {
    Channel: {
        /**
         * 获取主计划列表
         */
        list: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/master_plan/page`,
                params
            );
        },
        /**
         * 创建主计划
         */
        create: (params: any) => {
            return axios.post(`${ADMIN_API_ROOT}/master_plan`, params);
        },
        /**
         * 修改主计划
         */
        modify: (params: any) => {
            return axios.put(
                `${ADMIN_API_ROOT}/master_plan/${params.id}`,
                params
            );
        },
        /**
         * 获取主计划详情
         */
        detail: (params: { id: string | number }) => {
            return axios.get(`${ADMIN_API_ROOT}/master_plan/${params.id}`);
        },
        /**
         * 删除主计划
         */
        delete: (params: { ids: string[] | [] }) => {
            return axios.delete(
                `${ADMIN_API_ROOT}/master_plan/batch_delete`,
                { params }
            );
        },
        enabled: async (params: { id: string | number; enabled: boolean }) => {
            return axios.put(
                `${ADMIN_API_ROOT}/price_level/${params.id}/${params.enabled ? "enabled" : "disabled"
                }`,
                {}
            );
        },
    },
    Recharge: {
        /**
         * 充值列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/recharge/list`,
                { params }
            );
        },
        /**
         * 充值审核
         */
        approve: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/recharge/check`,
                params
            );
        },
        // 获取充值网络类型列表
        networkType: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/config/wallet-network-select`,
                { params }
            );
        },

        queryAccountSumbit: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/recharge/search-entry`,
                params
            );
        },

    },
    Withdrawal: {
        /**
         * 提现列表
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/withdraw/list`,
                { params }
            );
        },
        /**
         * 提现审核
         */
        approve: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/withdraw/check`,
                params
            );
        },
    },
    BalanceLog: {
        /**
         * 用户余额变更日志
         */
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/list`,
                { params }
            );
        },
        /**
         * 余额变动场景列表
         */
        scene: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/scene-list`,
                { params }
            );
        },
        /**
         * 余额变动状态列表
         */
        status: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/status-list`,
                { params }
            );
        },
        /**
         * 余额变动类型列表
         */
        track: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/track-id-list`,
                { params }
            );
        },
        export: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/export`,
                {
                    params,
                    headers: { "content-type": "application/json; charset=utf-8", },
                    responseType: "blob",
                    'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                },
            );
        },
    },
    UserAddress: {
        // 用户地址列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/member/address-list`,
                { params }
            );
        },
        // 删除用户钱包地址
        delete: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/member/address-delete`,
                { params }
            );
        },
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/member/address-update`,
                params
            );
        },
    },
    Usertransfer: {
        // 用户转账列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/balance-log/member-transfer-list`,
                { params }
            );
        },
    },
    InternationalRemittanceList: {
        // 国际汇款列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/banking/transfer-record-list`,
                { params }
            );
        },
        // 国际汇款审核
        audit: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking/transfer-record-audit`,
                params
            );
        },
        // 国际汇款更新备注
        updateRemark: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking/transfer-record-update`,
                params
            );
        },
    },
    InternationalRemittanceCountriesList: {
        // 国际汇款国家列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/banking-transfer-country/list`,
                { params }
            );
        },
        // 删除国际汇款国家
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-country/delete`,
                params
            );
        },
        // 新增国际汇款国家
        create: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-country/add`,
                params
            );
        },
        // 更新国际汇款国家
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-country/update`,
                params
            );
        },
    },
    InternationalRemittanceChannelList: {
        // 国际汇款通道列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/banking-transfer-channel/list`,
                { params }
            );
        },
        // 删除国际汇款通道
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-channel/delete`,
                params
            );
        },
        // 新增国际汇款通道
        create: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-channel/add`,
                params
            );
        },
        // 更新国际汇款通道
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-channel/update`,
                params
            );
        },
        // 通道下拉列表
        selectList: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/banking-transfer-channel/select-list`,
                { params }
            );
        },
    },
    InternationalRemittanceCreditedTimesList: {
        // 国际汇款通道时效列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/banking-transfer-channel/credited-times-list`,
                { params }
            );
        },
        // 删除国际汇款通道时效
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-channel/credited-times-delete`,
                params
            );
        },
        // 新增国际汇款通道时效
        create: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-channel/credited-times-add`,
                params
            );
        },
        // 更新国际汇款通道时效
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-channel/credited-times-update`,
                params
            );
        },
    },
    InternationalRemittanceLimitList: {
        // 国际汇款限额列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/banking-transfer-limit/list`,
                { params }
            );
        },
        // 删除国际汇款限额
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-limit/delete`,
                params
            );
        },
        // 新增国际汇款限额
        create: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-limit/add`,
                params
            );
        },
        // 更新国际汇款限额
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-limit/update`,
                params
            );
        },
    },
    InternationalRemittanceSlippageList: {
        // 国际汇款滑点列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/banking-transfer-slippage/list`,
                { params }
            );
        },
        // 删除国际汇款滑点
        delete: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-slippage/delete`,
                params
            );
        },
        // 新增国际汇款滑点
        create: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-slippage/add`,
                params
            );
        },
        // 更新国际汇款滑点
        update: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-slippage/update`,
                params
            );
        },
        // 获取汇率
        getExchangeRate: (params: any) => {
            return axios.post(
                `${ADMIN_API_ROOT}/banking-transfer-slippage/exchange-rate`,
                params 
            );
        },
    },
    InternationalRemittanceCurrencyConversionList: {
        // 国际汇款货币转换列表
        list: (params: any) => {
            return axios.get(
                `${ADMIN_API_ROOT}/banking-transfer-conversion/list`,
                { params }
            );
        },
    }
}